import InlineSvg from "vue-inline-svg";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import SwiperCore, { Navigation } from "swiper";

SwiperCore.use([Navigation]);

export default {
  name: "PostImageWithProductCarousel",
  components: {
    InlineSvg,
    Swiper,
    SwiperSlide,
  },
  props: ["productTags", "imgSrc", "imgId", "postIndex"],
  data() {
    return {
      activatedTag: 0,
      description: null,
      isLoaded: false,
      hasAdminLink: false,
      slideToSpeed: 300,

      swiperOptions: {
        margin: 40,
        slidesPerView: 3,
        spaceBetween: 4,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          disabledClass: "hide",
        },
      },
      showNext: false,
      showPrev: false,
      top: 0,
    };
  },
  methods: {
    handleTagClick,
    clearActivated,
    loaded,
    handleTagCTAClick,
    swiperClick,
    handleQuickShopClick,
    onSlideChange(swiper) {
      this.activatedTag = swiper.activeIndex;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
};

function loaded() {
  this.isLoaded = true;
}

function handleTagClick(currentPosition) {
  if (currentPosition !== this.activatedTag) {
    this.activatedTag = currentPosition;
    this.swiper.slideTo(this.activatedTag, this.slideToSpeed, true);
  }
}

function handleTagCTAClick() {
  const index = this.activatedTag - 1;
  this.$emit("product-tag-cta-clicked", this.postIndex, index);
  this.$router.push(this.description.url);
}

function clearActivated() {
  this.activatedTag = 0;
  this.activatedDescriptionBox = null;
}

function swiperClick(response) {
  const index = response.clickedIndex;
  this.activatedTag = index;
}

function handleQuickShopClick(tag) {
  this.$ma.trackEvent({
    action: "Quickshop Click - Feed",
  });
  this.$eventBus.$emit("show-quick-shop-modal-by-id", tag.product_id ? tag.product_id : tag.url.split("/").pop());
}
